<bottomsheet-layout (dismiss)="closeBottomSheet()">
  <div class="tw-px-2">
    <div class="tw-flex tw-justify-center">
      <div class="tw-relative tw-w-fit">
        <img [src]="productImage" class="tw-w-30 tw-h-[150px] tw-object-contain tw-rounded-3" alt="product" />
        <div class="tw-absolute tw-top-[10px] tw-right-0 tw-translate-x-1/2 tw-translate-y-0">
          <img src="/assets/images/exclamation_orange_inverted.png" class="tw-w-[37px] tw-h-[37px]" alt="exclamation" />
        </div>
      </div>
    </div>
    <p class="tw-text-700 tw-leading-[25px] tw-text-center tw-font-lexend tw-font-bold tw-mt-4 tw-mb-2.5 tw-capitalize" i18n="@@usersUnderAge16CantBuyThisProduct">users under age 16 can't buy this product</p>
    <p class="tw-font-body tw-text-300 tw-font-medium tw-text-gray-500 tw-text-center">
      <span> {{data.product.title}} </span>
      <span i18n="@@containsIngredientsNotRecommendedForTeenagers"> contains ingredients not recommended for teenagers and cannot be added to your cart. </span>
    </p>
  </div>

  <div class="tw-mt-8">
    <button csButton
            (click)='closeBottomSheet()'
            class="tw-max-w-full tw-w-full tw-text-500 tw-font-semibold tw-capitalize"
            style="margin: 0 !important;">
      <span i18n="@@okay">okay</span>
    </button>
  </div>
</bottomsheet-layout>
